import React from 'react';
import { Navigate } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import WabliBreadcrumb from '../WabliBreadcrumb';
import PersonalInfo from './PersonalInfo';
import AuthContext from '../AppAuthContext';
import { muiTheme } from '../../styling/Styles';

// This component is used to render profile page.
const ProfilePage = () => {
  const { state, dispatch } = React.useContext(AuthContext);

  // This statement is used to go to login page if user clicks on logout
  if (!state.isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <ThemeProvider theme={muiTheme}>
      <div style={{ height: '100%', overflow: 'auto' }}>
        <WabliAppBar />
        <WabliBreadcrumb name="my profile" />
        <PersonalInfo state={state} dispatch={dispatch} />
        <div style={{ marginTop: '1rem' }} />
      </div>
    </ThemeProvider>
  );
};

export default ProfilePage;
